import { render, staticRenderFns } from "./sisuhaldus.vue?vue&type=template&id=5229fe8d&"
import script from "./sisuhaldus.vue?vue&type=script&lang=js&"
export * from "./sisuhaldus.vue?vue&type=script&lang=js&"
import style0 from "./sisuhaldus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports